export const FETCH_DUPLICATE_TEMPLATE_REQUEST = 'FETCH_DUPLICATE_TEMPLATE_REQUEST'
export const FETCH_DUPLICATE_TEMPLATE_SUCCESS = 'FETCH_DUPLICATE_TEMPLATE_SUCCESS'
export const FETCH_DUPLICATE_TEMPLATE_FALUIRE = 'FETCH_DUPLICATE_TEMPLATE_FALUIRE'
